import type { CustomerConfig } from "../../types";

export const redhatConfig: CustomerConfig = {
	id: "redhat",
	name: "Red Hat",
	shortName: "Red Hat",
	accessTokens: ["61d51c98bf4d3c8ad180354d0f82591b"],
	accessExpiry: new Date("2026-05-17T23:59:59Z"),
	onsiteDates: "April 22, 2026",
	theme: {
		accentColor: "#ef4444",
		accentColorLight: "#f87171",
		secondaryAccent: "#fb923c",
		pathColorFrom: "#ef4444",
		pathColorTo: "#f43f5e",
		slideAccentBar: "#ef4444",
	},
	logos: {
		customer: "/assets/logos/redhat.png",
		null: "/null/logo.white.svg",
	},
	demoUrl: "https://app.dev.null.autos",
	demoLabel: "Launch Null Autos Platform",
	confidentialityNotice:
    "CONFIDENTIAL — Any disclosure, use, reproduction, or distribution of this information without the express written consent of Null Autos is strictly prohibited.",
};
